// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subaccounts_AsaasTriggerResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subaccounts_AsaasTriggerResponse — `dados` for
 * POST /subaccounts/webhooks/asaas-staff.
 *
 * Reports what the dispatch actually DID, so the transaction modal never has to
 * infer success from a bare 200. That distinction is load-bearing here: a
 * charge the platform does not own is answered 'ignored' with a reason, in a
 * perfectly successful HTTP response, and showing that as "webhook enviado"
 * would teach the operator to trust a button that did nothing.
 *
 * `lane` exists for the same reason. The ASAAS account serves two products, and
 * the single most useful thing to know after a simulated confirmation is which
 * one just moved: 'subscription' (a SaaS cycle) or 'one_off' (an AI-credit
 * top-up). It is the adapter's own classification, echoed — not re-derived.
 *
 * Shape:
 * {
 *   "provider_code":     "asaas",
 *   "event_type":        "PAYMENT_CONFIRMED",
 *   "lane":              "subscription",
 *   "provider_event_id": "evt_sim_68a1...",
 *   "webhook_id":        1234,
 *   "message":           "subscription_processed",
 *   "reason":            null
 * }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subaccounts_AsaasTriggerResponseDados {
provider_code: string
event_type: string
lane: string
provider_event_id: string
message: string
webhook_id?: number
reason?: string
}

export type Subaccounts_AsaasTriggerResponse = ApiResponse<Subaccounts_AsaasTriggerResponseDados>;

registerResponseContract('Subaccounts_AsaasTriggerResponse', {
  provider_code:     { type: 'string',  required: true },
  event_type:        { type: 'string',  required: true },
  lane:              { type: 'string',  required: true },
  provider_event_id: { type: 'string',  required: true },
  message:           { type: 'string',  required: true },
  webhook_id:        { type: 'number',  required: false },
  reason:            { type: 'string',  required: false },
})
